<template>
    <div class="sidebar">
        <el-menu
                class="sidebar-el-menu"
                :default-active="onRoutes"
                :collapse="collapse"
                background-color="#2d2e42"
                text-color="#bfcbd9"
                active-text-color="#20a0ff"
                unique-opened
                router
        >
            <template v-for="item in items">
                <template v-if="item.subs">
                    <el-submenu :index="item.index" :key="item.index">
                        <template slot="title">
                            <i :class="item.icon"></i>
                            <span slot="title">{{ item.title }}</span>
                        </template>
                        <template v-for="subItem in item.subs">
                            <el-submenu
                                    v-if="subItem.subs"
                                    :index="subItem.index"
                                    :key="subItem.index"
                            >
                                <template slot="title">{{ subItem.title }}</template>
                                <el-menu-item
                                        v-for="(threeItem,i) in subItem.subs"
                                        :key="i"
                                        :index="threeItem.index"
                                >{{ threeItem.title }}
                                </el-menu-item>
                            </el-submenu>
                            <el-menu-item
                                    v-else
                                    :index="subItem.index"
                                    :key="subItem.index"
                            >{{ subItem.title }}
                            </el-menu-item>
                        </template>
                    </el-submenu>
                </template>
                <template v-else>
                    <el-menu-item :index="item.index" :key="item.index">
                        <i :class="item.icon"></i>
                        <span slot="title">{{ item.title }}</span>
                    </el-menu-item>
                </template>
            </template>
        </el-menu>
    </div>
</template>

<script>
    import bus from '../common/bus';

    export default {
        data() {
            return {
                collapse: false,
                items: [
                    // {
                    //     icon: 'el-icon-lx-home',
                    //     index: 'dashboard',
                    //     title: '首页'
                    // },
                    {
                        icon: 'el-icon-lx-home',
                        index: 'index',
                        title: '首页'
                    },

                    {
                        icon: 'el-icon-lx-sort',
                        index: 'formwork',
                        title: '合同管理',
                        subs: [
                            // {
                            //     index: 'directInitiation',
                            //     title: '直接发起'
                            // },
                            {
                                index: 'formwork',
                                title: '模板发起'
                            },
                            {
                                index: 'contract',
                                title: '合同管理'
                            },
                            {
                                index: 'draftBox',
                                title: '草稿箱'
                            },
                            {
                                index: 'orderList',
                                title: '订单管理'
                            },
                        ]
                    },
                    {
                        icon: 'el-icon-lx-sort',
                        index: 'lawCase',
                        title: '案件管理',
                        subs: [
                            {
                                index: 'lawCase',
                                title: '仲裁案件管理'
                            },
                            {
                                index: 'mediate',
                                title: '仲裁调解案件管理'
                            },
                            {
                                index: 'mediationCenter',
                                title: '调解中心案件'
                            },
                            {
                                index: 'templatePage',
                                title: '调解中心模板管理'
                            },
                            // {
                            //     index: 'insurePage',
                            //     title: '投保案件管理'
                            // },
                        ]
                    },

                    // {
                    //     icon: 'el-icon-lx-vipcard',
                    //     index: 'draftBox',
                    //     title: '草稿箱'
                    // },
                    // {
                    //     icon: 'el-icon-lx-cascades',
                    //     index: 'contract',
                    //     title: '存证管理',
                    //     subs: [
                    //         {
                    //             index: 'contract',
                    //             title: '合同管理'
                    //         }
                    //
                    //     ]
                    // },
                    // {
                    //     icon: 'el-icon-lx-sort',
                    //     index: 'orderList',
                    //     title: '订单管理'
                    // },
                    // {
                    //     icon: 'el-icon-lx-vipcard',
                    //     index: 'evidence',
                    //     title: '证据存证'
                    // },
                    // {
                    //     icon: 'el-icon-lx-edit',
                    //     index: 'case',
                    //     title: '案件管理'
                    // },
                    // {
                    //     icon: 'el-icon-lx-sort',
                    //     index: 'order',
                    //     title: '订单管理'
                    // },
                    // {
                    //     icon: 'el-icon-lx-calendar',
                    //     index: 'homePage',
                    //     title: '发起仲裁'
                    // },
                    // {
                    //     icon: 'el-icon-lx-edit',
                    //     index: 'lawCase',
                    //     title: '仲裁案件管理'
                    // },
                    // {
                    //     icon: 'el-icon-lx-sort',
                    //     index: 'mediate',
                    //     title: '仲裁调解案件管理'
                    // },
                    // {
                    //     icon: 'el-icon-lx-edit',
                    //     index: 'insurePage',
                    //     title: '投保案件管理'
                    // },
                    // {
                    //     icon: 'el-icon-lx-sort',
                    //     index: 'mediationCenter',
                    //     title: '商事调解中心案件管理',
                    //     subs: [
                    //         {
                    //             index: 'mediationCenter',
                    //             title: '调解中心案件'
                    //         },
                    //         {
                    //             index: 'templatePage',
                    //             title: '模板管理'
                    //         }
                    //     ]
                    // },
                    {
                        icon: 'el-icon-lx-sort',
                        index:'clueList',
                        title:'呼叫中心',
                        subs:[
                            {
                                index:'clueList',
                                title:'线索管理列表'
                            },
                            {
                                index:'allCallLog',
                                title:'全部通话记录'
                            },
                            {
                                index:'callStatistics',
                                title:'通话统计'
                            }
                        ]
                    },
                    // {
                    //     icon: 'el-icon-document-copy',
                    //     index: 'templateList',
                    //     title: '模板管理'
                    // },
                    {
                        icon: 'el-icon-monitor',
                        index:'visualization',
                        title:'可视化大屏',
                    },

                    // {
                    //     icon: 'el-icon-lx-calendar',
                    //     index: '3',
                    //     title: '表单相关',
                    //     subs: [
                    //         {
                    //             index: 'form',
                    //             title: '基本表单'
                    //         },
                    //         {
                    //             index: 'upload',
                    //             title: '文件上传'
                    //         }
                    //     ]
                    // },
                    // {
                    //     icon: 'el-icon-lx-warn',
                    //     index: '7',
                    //     title: '错误处理',
                    //     subs: [
                    //         {
                    //             index: 'permission',
                    //             title: '权限测试'
                    //         },
                    //         {
                    //             index: '404',
                    //             title: '404页面'
                    //         }
                    //     ]
                    // },
                    // {
                    //     icon: 'el-icon-lx-redpacket_fill',
                    //     index: '/donate',
                    //     title: '支持作者'
                    // }
                ]
            };
        },
        computed: {
            onRoutes() {
                return this.$route.path.replace('/', '');
            }
        },
        created() {
            setTimeout(() => {
                var staff = JSON.parse(sessionStorage.getItem('shenfen'));
                if (staff.user_type == 2) {
                    this.items[1].subs.push(
                        {
                            index: 'wholeContract',
                            title: '全部合同'
                        }
                    );
                }
                if (staff.mode == 1){
                    this.items[1].subs.unshift(
                        {
                            index: 'directInitiation',
                            title: '直接发起'
                        },
                    )
                }else {
                    this.items[1].subs.unshift(
                        {
                            index: 'directInitiation_pay',
                            title: '直接发起'
                        },
                    )
                }
                if (staff.user_type==1 || staff.user_type==2){
                    this.items.splice(4,0,
                        {
                            icon: 'el-icon-document-copy',
                            index: 'templateList',
                            title: '模板管理'
                        },
                    )
                }
                if (staff.wx_status == 2){
                    // this.items.push(
                    //     {
                    //         icon: 'el-icon-tickets',
                    //         index:'service',
                    //         title:'服务管理',
                    //     }
                    // )
                    this.items.push(
                        {
                            icon: 'el-icon-tickets',
                            index:'service',
                            title:'会员管理',
                        }
                    )
                }
            }, 1000);
            // 通过 Event Bus 进行组件间通信，来折叠侧边栏
            bus.$on('collapse', msg => {
                this.collapse = msg;
                bus.$emit('collapse-content', msg);
            });
        }
    };
</script>

<style scoped>
    .sidebar {
        display: block;
        position: absolute;
        left: 0;
        top: 70px;
        bottom: 0;
        overflow-y: scroll;
        background-color: #2d2e42;
    }

    .sidebar::-webkit-scrollbar {
        width: 0;
    }

    .sidebar-el-menu:not(.el-menu--collapse) {
        width: 250px;
    }

    .sidebar > ul {
        height: 100%;
    }
</style>
